module.exports = __webpack_public_path__ + "img/rejeitado.8dc66259.png";